<template>
    <div class="repay__bank-card">
        <div class="repay__bank-card__title">
            <img class="repay__bank-card__title-images" src="@/assets/img/how-to-pay-off/how_to_repay_cover.png" alt="" />
            <div class="repay__bank-card__title-text">Как погасить</div>
            <div class="repay__bank-card__title-description">При погашении микрокредита вам нужно точно придерживаться графика <br/>платежей, он будет указан в вашем «Личном кабинете»</div>
        </div>
        <div class="repay__bank-card__info">
            <div class="repay__bank-card__info-title">
                <img class="repay__bank-card__info-icon" src="@/assets/svg/icons/icon_1_mk.svg" alt="" />
                <p class="repay__bank-card__info-text">Как внести платёж с банковской карты Visa или MasterCard</p>
            </div>
            <div class="repay__bank-card__info-description">Вы можете зарегистрировать в личном кабинете на microfin.kz несколько банковских карт и при оплате использовать любую из них.<br/><br/>Мы рекомендуем зарегистрировать одну или несколько карт – тогда данные<br/>не придётся вводить повторно
            </div>
        </div>
        <div class="repay__bank-card__screenshot">
            <div class="repay__bank-card__screenshot-title">Для оплаты банковской картой зайдите на microfin.kz</div>
            <div class="repay__bank-card__screenshot-step step--first">
                <div class="repay__bank-card__screenshot-step-title">Шаг 1</div>
                <img class="repay__bank-card__screenshot-step-image" src="@/assets/img/how-to-pay-off/bc_qt_1.png" alt="" />
            </div>
            <div class="repay__bank-card__screenshot-step step--second">
                <div class="repay__bank-card__screenshot-step-title">Шаг 2</div>
                <img class="repay__bank-card__screenshot-step-image" src="@/assets/img/how-to-pay-off/bc_qt_2.png" alt="" />
            </div>
            <div class="repay__bank-card__screenshot-step step--third">
                <div class="repay__bank-card__screenshot-step-title">Шаг 3</div>
                <img class="repay__bank-card__screenshot-step-image" src="@/assets/img/how-to-pay-off/bc_qt_3.png" alt="" />
            </div>
            <div class="repay__bank-card__screenshot-step step--fourth">
                <div class="repay__bank-card__screenshot-step-title">Шаг 4</div>
                <img class="repay__bank-card__screenshot-step-image" src="@/assets/img/how-to-pay-off/bc_qt_4.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
    export default{
    	name: 'RepayBankCard',
        metaInfo: {
    	    title: 'Как внести платёж с банковской карты – Микро',
            meta: [
                {name: 'description', content: 'Вы можете зарегистрировать в личном кабинете на microfin.kz несколько банковских карт и при оплате использовать любую из них'}
            ],
        },
        computed: {
        },
    }
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.repay__bank-card {
    width: 100%;
    &__title {
        display: inline-flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: flex-start;

        width: 100%;
        margin-bottom: 44px;
    }
    &__title-images {
        width: 583px;
        height: 338px;
        margin-bottom: 35px;
    }
    &__title-text {
        margin-bottom: 20px;
        color: $purple-site;
        text-align: left;
        font-family: $MontserratBold;
        font-size: 30px;
    }
    &__title-description {
        text-align: left;
        color: $gray-dim-dark;
        font-size: 18px;
        line-height: 27px;
        font-family: $RobotoBold;
    }

    &__info {
        display: inline-flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: flex-start;

        width: 100%;
        margin-bottom: 29px;
    }
    &__info-title {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        border-bottom: 1px solid $gray-mint;
        padding-bottom: 18px;
        margin-bottom: 21px;
    }
    &__info-icon {
        width: 65px;
        height: 44px;
    }
    &__info-text {
        margin-left: 21px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__info-title {

    }
    &__info-description {
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 24px;
        font-family: $RobotoRegular;
    }

    &__screenshot {}
    &__screenshot-title {
        margin-bottom: 13px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__screenshot-step {
        display: inline-flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: flex-start;

        width: 100%;
        margin-bottom: 58px;
    }
    &__screenshot-step-title {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        height: 50px;
        margin-bottom: 11px;
        padding-left: 28px;
        background: $orange-o-25;

        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__screenshot-step-image {
        width: auto;
    }
}
@media screen and (max-width: 768px) {
    .repay__bank-card {
        &__screenshot-step-image,
        &__title-images {
            max-width: fit-content;
            width: 100%;
            height: auto;
        }
    }
}
</style>